import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const _styles = {
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme =>
      theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
      }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  header: {
    borderBottom: '1px solid #e0e0d9',
    borderTop: '1px solid #e0e0d9',
  },
  collapsed: {},
  root: {
    '$collapsed + & > $header': {
      borderTop: 0,
    },
  },
};

function AccordionDrawer(props) {
  const { title, children, expanded, onExpandChange, summaryProps, detailsProps, ...other } = props;

  return (
    <Accordion {...other} expanded={expanded} onChange={onExpandChange}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} {...summaryProps}>
        {title}
      </AccordionSummary>
      <AccordionDetails {...detailsProps}>{children}</AccordionDetails>
    </Accordion>
  );
}

AccordionDrawer.propTypes = {
  title: PropTypes.string.isRequired,
  expanded: PropTypes.bool,
  onExpandChange: PropTypes.func,
  summaryProps: PropTypes.object,
  detailsProps: PropTypes.object,
  children: PropTypes.any.isRequired,
};

AccordionDrawer.defaultProps = {
  style: {},
  expanded: null,
  onExpandChange: () => {},
  summaryProps: {},
  detailsProps: {},
};

export default AccordionDrawer;
